import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder } from '@angular/forms';
import { CapacitacionService } from '../../services/capacitacion.service';
import { ComboBuilderService } from '../../services/combo-builder.service';
import { ValidationService } from '../../services/validation.service';
import { EvidenciaService } from '../../services/evidencia.service';
import { LoginService } from '../../services/login.service';
import { EJECUTOR_OTHERS_ID, } from '../../utils/constants';
import { ToastrService } from 'ngx-toastr';
import { ZoneService } from 'src/app/services/zone.service';
import { UserService } from 'src/app/services/user.service';
import { CategoryService } from 'src/app/services/category.service';
import { EventMantenedorCategoriaService } from 'src/app/services/event-mantenedor-categoria.service';
import { EjecutorService } from 'src/app/services/ejecutor.service';
import { EventMantenedorEjecutorService } from 'src/app/services/event-mantenedor-ejecutor.service';
export class EjecutorModalComponent {
    constructor(modalService, capacitacionService, comboBuilderService, validationService, evidenciaService, fb, userService, toastr, zoneService, categoriaService, ejecutorService, eventMantenedorEjecutorService, eventMantenedorCategoriaService, loginService) {
        this.modalService = modalService;
        this.capacitacionService = capacitacionService;
        this.comboBuilderService = comboBuilderService;
        this.validationService = validationService;
        this.evidenciaService = evidenciaService;
        this.fb = fb;
        this.userService = userService;
        this.toastr = toastr;
        this.zoneService = zoneService;
        this.categoriaService = categoriaService;
        this.ejecutorService = ejecutorService;
        this.eventMantenedorEjecutorService = eventMantenedorEjecutorService;
        this.eventMantenedorCategoriaService = eventMantenedorCategoriaService;
        this.loginService = loginService;
        this.createEdit = new EventEmitter();
        this.accept = new EventEmitter();
        this.reject = new EventEmitter();
        this.enfoques = [];
        this.categoriesWithFocos = [];
        this.zonas = [];
        this.userZonas = [];
        this.ejecutoresWithRelatores = [];
        this.categoria = {
            ejecutorId: null,
            descripcion: '',
            estado: true
        };
        this.errors = {
            estado: false,
            name: false
        };
        this.flags = {
            ejecutor: false,
            relator: false,
            duracionTeorica: false,
            duracionPractica: false,
            fechaEjecucionReal: false,
            Evidencia: false,
            AsignacionParticipantes: false,
            Guardar: false
        };
        this.isRead = false;
        this.flagPassword = false;
        this.showBar = false;
        this.isReadOnEdit = false;
        this.focoCombo = [];
        this.relatorCombo = [];
        this.monthsCombo = [];
        this.ejecutorOthersId = EJECUTOR_OTHERS_ID;
        this.showErrorMessage = false;
        this.showEvidenceMessage = false;
        this.confirmationModalHasComment = false;
        this.confirmationModalHasOptions = false;
        this.confirmationModalisCommentObligatory = false;
        this.workersIdSelected = [];
        this.workersSelected = [];
        this.workersColumns = [
            'Rut Trabajador',
            'Nombre',
            'Apellido Paterno',
            'Apellido Materno'
        ];
        this.workersRows = [];
        this.year = new Date().getFullYear();
        this.yearMax = this.year + 4;
        this.loading = false;
        this.evidences = [];
        this.fileData = null;
        this.error = false;
        this.errorMessage = '';
        this.listClass = false;
        this.flagZona = false;
        this.form = this.fb.group({
            evidenceFile: [null]
        });
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.loginService.obtenerPermisosMenu('mantenedores').then((response) => {
                this.rolid = response.data.rolId;
            });
        });
    }
    getLabel(value, defaultValue) {
        return value ? value.toString() : defaultValue;
    }
    changeInput(field, value, type = '') {
        if (field === 'estadoId') {
            if (value === 'true') {
                this.categoria.estado = true;
            }
            else {
                this.categoria.estado = false;
            }
        }
        this.categoria[field] = value;
    }
    onSave(send = false) {
        this.showErrorMessage = false;
        this.showEvidenceMessage = false;
        if (this.isValid()) {
            this.loading = true;
            if (this.mode === 'Editar') {
                const categoria = this.categoria;
                const request = {
                    ejecutor: {
                        ejecutorId: categoria.ejecutorId,
                        descripcion: categoria.descripcion,
                        estado: categoria.estado
                    }
                };
                this.ejecutorService.update(request, categoria.ejecutorId)
                    .then(response => {
                    this.createEdit.emit('Ejecutor modificado correctamente');
                    this.eventMantenedorEjecutorService.refreshTable();
                    this.loading = false;
                    this.modalCategoria.dismiss('Cancel');
                })
                    .catch(error => console.error(error));
            }
            else {
                const categoria = this.categoria;
                const request = {
                    newEjecutor: {
                        descripcion: categoria.descripcion,
                        estado: categoria.estado
                    }
                };
                this.ejecutorService.create(request)
                    .then(response => {
                    this.createEdit.emit('Ejecutor creado correctamente');
                    this.eventMantenedorEjecutorService.refreshTable();
                    this.loading = false;
                    this.modalCategoria.dismiss('Cancel');
                })
                    .catch(error => console.error(error));
            }
        }
    }
    isValid() {
        let isValid = true;
        const isNameValid = this.categoria.descripcion && this.categoria.descripcion.length <= 50;
        isValid = isValid ? isNameValid : false;
        this.errors.name = !isNameValid;
        if (this.mode == 'Editar') {
            const isEstadoIdValid = this.categoria.estado != null;
            isValid = isValid ? isEstadoIdValid : false;
            this.errors.estado = !isEstadoIdValid;
        }
        return isValid;
    }
}
